// Lista identificadores de serviços da API
export const IdentificadorServico = Object.freeze({
  OAB_PROCESSOS : 'OAB_PROCESSOS',
  ENVOLVIDO_PROCESSOS : 'ENVOLVIDO_PROCESSOS',
  CAPA_PROCESSO: 'CAPA_PROCESSO',
  ATUALIZACAO_PROCESSO: 'ATUALIZACAO_PROCESSO',
  STATUS_ATUALIZACAO_PROCESSO : 'STATUS_ATUALIZACAO_PROCESSO',
  PROCESSO_MOVIMENTACOES : 'PROCESSO_MOVIMENTACOES',
  ATUALIZACAO_PROCESSO_RESUMO_IA : 'ATUALIZACAO_PROCESSO_RESUMO_IA',
  PROCESSO_RESUMO_IA : 'PROCESSO_RESUMO_IA',
  STATUS_RESUMO_INTELIGENTE : 'STATUS_RESUMO_IA',
});
